
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaiairporttonashikairport() {



    const cardData =
    {
        keyword: 'Mumbai airport to nashik cab',
        heading: 'Skyline Cabs: Mumbai airport to nashik cab',
        headingDescription: 'Skyline Cabs offers comfortable and reliable Mumbai Airport to Nashik Cab services for a smooth and timely journey. Whether you are traveling for business, a spiritual visit, or to explore the vineyards of Nashik, our well-maintained vehicles and professional drivers ensure a stress-free ride. Enjoy convenient pickups directly from Chhatrapati Shivaji Maharaj International Airport, transparent pricing, flexible travel options, and 24/7 customer support. Book your Mumbai Airport to Nashik cab with Skyline Cabs today and experience a safe and comfortable trip to the Wine Capital of India!',

        top: 'Top Places to Visit in Nashik with Skyline Cabs',

"topPlaces": [
    {
        "title": "Trimbakeshwar Temple",
        "description": "One of the twelve Jyotirlingas in India, Trimbakeshwar Temple is a major pilgrimage site dedicated to Lord Shiva. Located near the source of the Godavari River, the temple is known for its unique architecture and spiritual significance."
    },
    {
        "title": "Sula Vineyards",
        "description": "India’s most famous vineyard, Sula Vineyards offers wine tastings, vineyard tours, and a relaxed ambience amidst lush surroundings. It’s a perfect getaway for wine lovers and those seeking a peaceful retreat."
    },
    {
        "title": "Pandav Leni Caves",
        "description": "Dating back to the 1st century BC, these ancient rock-cut caves are a series of Buddhist monasteries featuring intricate carvings and sculptures. A short hike leads to stunning views of the city below."
    },
    {
        "title": "Kalaram Temple",
        "description": "An important Hindu temple dedicated to Lord Rama, the Kalaram Temple is renowned for its black stone idol of Lord Rama and beautiful architecture. It holds great religious importance in the region."
    },
    {
        "title": "Anjneri Hill",
        "description": "Believed to be the birthplace of Lord Hanuman, Anjneri Hill is a popular trekking destination. The hill offers panoramic views, spiritual vibes, and a serene escape into nature."
    },
    {
        "title": "Saptashrungi Devi Temple",
        "description": "Located around 60 km from Nashik, this sacred temple dedicated to Goddess Saptashrungi is perched on a hill and can be reached by steps or ropeway. It is one of the 51 Shakti Peethas in India."
    },
    {
        "title": "Ramkund",
        "description": "A sacred bathing ghat on the Godavari River, Ramkund is where devotees perform rituals and immerse ashes of departed loved ones. It is an important part of the Kumbh Mela held every 12 years in Nashik."
    },
    {
        "title": "Coin Museum",
        "description": "The only museum of its kind in India, the Coin Museum in Nashik offers a deep dive into the history of Indian coinage, with fascinating exhibits of coins, dyes, and minting techniques."
    },
    {
        "title": "Dugarwadi Waterfall",
        "description": "Located about 30 km from Nashik, this seasonal waterfall is a monsoon delight, surrounded by lush greenery and peaceful natural surroundings. It’s perfect for a short trek and picnic."
    },
    {
        "title": "York Winery",
        "description": "Another prominent winery in Nashik, York Winery offers a quieter, more intimate wine-tasting experience with stunning views of the Gangapur Dam and surrounding vineyards."
    }
],

"services": [
    {
      "name": "Mumbai Airport to Nashik Cab",
      "description": "Skyline Cabs offers reliable and comfortable taxi services from Mumbai Airport to Nashik. Enjoy a smooth ride with professional drivers for a stress-free journey."
    },
    {
      "name": "Taxi from Mumbai Airport to Nashik",
      "description": "Book a taxi from Mumbai Airport to Nashik with Skyline Cabs. We offer timely and comfortable rides with experienced drivers to ensure a smooth trip."
    },
    {
      "name": "Mumbai to Nashik One Way Taxi",
      "description": "Rent a one-way taxi from Mumbai to Nashik with Skyline Cabs. Perfect for travelers who need a direct, comfortable journey without the hassle of round-trip planning."
    },
    {
      "name": "Nashik Taxi Service from Mumbai Airport",
      "description": "Skyline Cabs provides top-quality taxi service from Mumbai Airport to Nashik. Travel comfortably with our reliable and punctual drivers."
    },
    {
      "name": "Mumbai Airport Nashik Cab Booking",
      "description": "Book a cab from Mumbai Airport to Nashik easily with Skyline Cabs. Our booking system is fast and simple, ensuring a seamless travel experience."
    }
  ],
  "tableData": [
    ["Mumbai Airport to Nashik Cab", "Taxi from Mumbai Airport to Nashik"],
    ["Mumbai to Nashik One Way Taxi", "Nashik Taxi Service from Mumbai Airport"],
    ["Mumbai Airport Nashik Cab Booking"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Mumbai Airport to Nashik Cab Service",
      "WhyChoosedescription": "Travel from Mumbai Airport to Nashik with ease and comfort. Our dependable cab service ensures a smooth and timely journey, whether you’re traveling for business, leisure, or a family visit."
    },
    {
      "WhyChooseheading": "Comfortable and Long-Distance Friendly Vehicles",
      "WhyChoosedescription": "Our cabs are ideal for long-distance travel, offering spacious interiors, air conditioning, and a smooth ride—making your trip from Mumbai Airport to Nashik relaxing and enjoyable."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Enjoy competitive, honest pricing with no hidden charges. Our clear and upfront rates provide value-for-money travel from Mumbai Airport to Nashik."
    },
    {
      "WhyChooseheading": "Professional and Courteous Drivers",
      "WhyChoosedescription": "Our drivers are experienced, well-mannered, and familiar with the airport pickup process and Nashik route, ensuring a safe, smooth, and on-time journey."
    },
    {
      "WhyChooseheading": "Punctual Airport Pickups",
      "WhyChoosedescription": "We monitor flight timings to ensure timely pickups, so you don’t have to wait or worry. Your comfort and convenience are our priority right from the terminal."
    },
    {
      "WhyChooseheading": "Sanitized and Well-Maintained Vehicles",
      "WhyChoosedescription": "All our cabs are cleaned, sanitized, and maintained to high standards for hygiene and safety, ensuring a stress-free ride to Nashik."
    },
    {
      "WhyChooseheading": "Flexible Travel Options",
      "WhyChoosedescription": "Choose from one-way or round-trip options with flexible timings to suit your travel schedule from Mumbai Airport to Nashik."
    },
    {
      "WhyChooseheading": "24/7 Booking and Customer Support",
      "WhyChoosedescription": "Book online or by phone anytime. Our 24/7 customer support team is always available to assist you with bookings, updates, or inquiries."
    }
  ]
  
  
  
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai Airport to Nashik with Skyline Cabs?',
            answer:
                'Booking a cab from Mumbai Airport to Nashik is quick and easy with Skyline Cabs. You can book via our website, mobile app, or by calling our customer support. Just share your flight details, drop location in Nashik, and preferred vehicle to get started.',
        },
        {
            id: 2,
            question: 'What is the distance and travel time from Mumbai Airport to Nashik?',
            answer:
                'The distance from Mumbai Airport to Nashik is approximately 165 km. The travel time is around 3.5 to 4.5 hours, depending on traffic and road conditions. Our drivers ensure a smooth and timely ride.',
        },
        {
            id: 3,
            question: 'Which vehicles are available for the Mumbai Airport to Nashik journey?',
            answer:
                'Skyline Cabs offers a range of vehicles including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and SUVs. For larger groups, we also provide Tempo Travellers. You can choose a vehicle based on your comfort and group size.',
        },
        {
            id: 4,
            question: 'Are the cab fares from Mumbai Airport to Nashik fixed?',
            answer:
                'Yes, we offer fixed and transparent pricing. The fare includes vehicle rental, driver allowance, fuel, tolls, and applicable taxes. No hidden charges—you get the complete fare before booking confirmation.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab from Mumbai Airport to Nashik?',
            answer:
                'Yes, we offer one-way cab services from Mumbai Airport to Nashik. You can also book a round-trip if you plan to return the same or next day.',
        },
        {
            id: 6,
            question: 'Is it possible to request a cab with extra luggage space?',
            answer:
                'Absolutely. If you have extra luggage, we recommend booking an SUV or a larger vehicle like Innova Crysta or Ertiga for more boot space. Just mention your requirement during the booking process.',
        },
        {
            id: 7,
            question: 'Do you offer pickup from both domestic and international terminals?',
            answer:
                'Yes, Skyline Cabs provides pickups from both Terminal 1 (domestic) and Terminal 2 (international) of Mumbai Airport. Our drivers track your flight to ensure timely pickup.',
        },
        {
            id: 8,
            question: 'What payment options are available for this route?',
            answer:
                'We accept UPI, credit/debit cards, net banking, and cash payments after the trip. Online transactions are securely processed via trusted gateways.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my Mumbai Airport to Nashik cab booking?',
            answer:
                'Yes, Skyline Cabs allows easy cancellation or modification of bookings through our website, app, or customer support. Our policies are flexible to accommodate last-minute changes.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for the Mumbai Airport to Nashik trip?',
            answer:
                'Skyline Cabs ensures a comfortable and reliable transfer from Mumbai Airport to Nashik. With clean vehicles, courteous drivers, and all-inclusive pricing, your journey will be stress-free from the moment you land.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Alok Tiwari",
            rating: 5,
            review: "Booked a cab from Mumbai Airport to Nashik for my business trip. The driver was waiting at the terminal, very professional and helpful. Smooth ride and great service!"
        },
        {
            name: "Mrs. Neha Kulkarni",
            rating: 4,
            review: "Travelled with family from Mumbai Airport to Nashik. The car was clean, spacious, and the journey was comfortable. Would’ve loved a little more music or entertainment, but otherwise, it was perfect!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Nashik Cabs",
  "image": "https://skylinecabs.com/assets/images/mumbai-airport-to-nashik-cabs.jpg",
  "description": "Book Mumbai Airport to Nashik cabs with Skyline Cabs for a smooth and reliable journey. Choose from AC sedans, SUVs, and luxury vehicles with on-time airport pickup, professional chauffeurs, and 24/7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8327"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-airport-to-nashik-cabs"
  }
};



     
      

    return (
        <div>
 <Helmet>
  <title>Mumbai Airport to Nashik Cabs | Safe Airport Pickup & Drop | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai Airport to Nashik cabs with Skyline Cabs for a smooth and reliable journey. Choose from AC sedans, SUVs, and luxury vehicles with on-time airport pickup, professional chauffeurs, and 24/7 availability." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Airport to Nashik Cabs, Airport Taxi Mumbai to Nashik, One Way Cab Mumbai Airport to Nashik, AC Cab Mumbai Airport, Sedan Taxi Mumbai Airport to Nashik, SUV Cab Hire Mumbai to Nashik, Luxury Cab Mumbai Airport Pickup, 24/7 Airport Drop Taxi, Skyline Cabs Mumbai Nashik" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/99.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaiairporttonashikairport;